import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

export default function BadgeItem( data ) {
  return (
    <Link to={ data.to } className="media">
      <Img fixed={ data.img.childImageSharp.fixed } />
      <div className="media-content">
        <div className="title">{ data.title }</div>
        <div className="subtitle">{ data.subtitle }</div>
      </div>
    </Link>
  )
}

export const badgeFragment = graphql`
  fragment BadgeImage on File {
    childImageSharp {
      fixed(width: 100, height: 100) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`
